import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {faTriangleExclamation} from '@fortawesome/pro-solid-svg-icons';
import {BicButtonComponent} from '@buildinginformationcloud/bic-ui-components';
import {MyCheckProposal} from '../../../../services/mycheck-proposal.service';

/**
 * Rein präsentationaler Banner für einen chatBIC-Änderungsvorschlag: Zusammenfassung, „Änderungen
 * übernehmen"/„Verwerfen" sowie eine Warnzeile, wenn der Vorschlag `stale` ist (der Nutzer hat den
 * myCheck seit `baseFingerprint` bereits selbst gespeichert). Keine eigene HTTP-Logik – `apply`/
 * `discard` löst der jeweilige Editor über `MyCheckProposalService` aus.
 *
 * Typneutral (KI/IDS/Hybrid gemeinsam nutzbar): kennt nur `MyCheckProposal`, keine KI-spezifische
 * Struktur.
 */
@Component({
  selector: 'app-proposal-banner',
  standalone: true,
  imports: [FaIconComponent, BicButtonComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './proposal-banner.component.html',
})
export class ProposalBannerComponent {
  @Input({required: true}) proposal!: MyCheckProposal;
  @Output() applyClicked = new EventEmitter<void>();
  @Output() discardClicked = new EventEmitter<void>();

  protected readonly faTriangleExclamation = faTriangleExclamation;
}
